import React from 'react';
import { Ticket } from 'lucide-react';
import { eventInfo } from '../data/mock';

// Mobile-only sticky CTA bar. Renders above safe-area at bottom of screen.
// Hides on /vendor-sponsor, /legal, /press to keep those pages distraction-free.
const HIDE_ON_PATHS = ['/vendor-sponsor', '/legal', '/privacy', '/terms', '/refund-policy', '/press', '/media'];

const MobileStickyCTA = () => {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/';
  if (HIDE_ON_PATHS.some((p) => path.startsWith(p))) return null;

  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 px-3 pt-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))] bg-gradient-to-t from-black via-black/95 to-black/0 backdrop-blur-sm"
    >
      <a
        href={eventInfo.ticketUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-sticky-cta-link"
        className="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-pink-500 via-orange-500 to-yellow-500 hover:from-pink-600 hover:via-orange-600 hover:to-yellow-600 text-white font-black text-base py-3.5 rounded-full shadow-2xl shadow-pink-500/40 active:scale-[0.98] transition-transform"
      >
        <Ticket className="w-5 h-5" />
        <span>Get Tickets · June 20</span>
      </a>
    </div>
  );
};

export default MobileStickyCTA;
